"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ExternalLink } from "lucide-react";
import type { ResolvedListing } from "../utils/resolveMatchListings";
import { BroadcasterLogo } from "./BroadcasterLogo";
type Variant = "inline" | "card";
interface Props {
  listing: ResolvedListing;
  showName?: boolean;
  /** `inline` for text-row contexts, `card` for the modal list. */
  variant?: Variant;
}
export function BroadcasterListItem(t0) {
  const $ = _c(32);
  const {
    listing,
    showName: t1,
    variant: t2
  } = t0;
  const showName = t1 === undefined ? true : t1;
  const variant = t2 === undefined ? "inline" : t2;
  const {
    channel,
    watchUrlOverride,
    note
  } = listing;
  const href = watchUrlOverride || channel.homepageUrl || null;
  if (variant === "card") {
    let t3;
    if ($[0] !== channel) {
      t3 = <BroadcasterLogo channel={channel} size="lg" />;
      $[0] = channel;
      $[1] = t3;
    } else {
      t3 = $[1];
    }
    let t4;
    if ($[2] !== href) {
      t4 = href && <ExternalLink className="w-3 h-3 shrink-0 opacity-30 group-hover:opacity-70 transition-opacity" aria-hidden="true" />;
      $[2] = href;
      $[3] = t4;
    } else {
      t4 = $[3];
    }
    let t5;
    if ($[4] !== t3 || $[5] !== t4) {
      t5 = <>{t3}{t4}</>;
      $[4] = t3;
      $[5] = t4;
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    const inner = t5;
    let t6;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = ["tv-broadcaster group", "inline-flex items-center gap-2", "h-14 px-3 rounded-md", "border border-border", "bg-background"];
      $[7] = t6;
    } else {
      t6 = $[7];
    }
    const baseClass = t6.join(" ");
    const tip = note ? `${channel.name} — ${note}` : channel.name;
    if (!href) {
      let t7;
      if ($[8] !== inner || $[9] !== tip) {
        t7 = <span className={baseClass} title={tip}>{inner}</span>;
        $[8] = inner;
        $[9] = tip;
        $[10] = t7;
      } else {
        t7 = $[10];
      }
      return t7;
    }
    let t7;
    if ($[11] !== channel.name || $[12] !== href || $[13] !== inner || $[14] !== tip) {
      t7 = <a href={href} target="_blank" rel="nofollow noopener" title={tip} aria-label={channel.name} className={`${baseClass} hover:bg-muted/60 hover:border-primary/40 transition-colors`}>{inner}</a>;
      $[11] = channel.name;
      $[12] = href;
      $[13] = inner;
      $[14] = tip;
      $[15] = t7;
    } else {
      t7 = $[15];
    }
    return t7;
  }
  let t3;
  if ($[16] !== channel) {
    t3 = <BroadcasterLogo channel={channel} size="sm" />;
    $[16] = channel;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  let t4;
  if ($[18] !== channel || $[19] !== showName) {
    t4 = showName && <span>{channel.name}</span>;
    $[18] = channel;
    $[19] = showName;
    $[20] = t4;
  } else {
    t4 = $[20];
  }
  let t5;
  if ($[21] !== note) {
    t5 = note && <span className="text-xs opacity-70">({note})</span>;
    $[21] = note;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  let t6;
  if ($[23] !== t3 || $[24] !== t4 || $[25] !== t5) {
    t6 = <span className="inline-flex items-center gap-2">{t3}{t4}{t5}</span>;
    $[23] = t3;
    $[24] = t4;
    $[25] = t5;
    $[26] = t6;
  } else {
    t6 = $[26];
  }
  const content = t6;
  if (!href) {
    let t7;
    if ($[27] !== content) {
      t7 = <span className="tv-broadcaster">{content}</span>;
      $[27] = content;
      $[28] = t7;
    } else {
      t7 = $[28];
    }
    return t7;
  }
  let t7;
  if ($[29] !== content || $[30] !== href) {
    t7 = <a href={href} target="_blank" rel="nofollow noopener" className="tv-broadcaster">{content}</a>;
    $[29] = content;
    $[30] = href;
    $[31] = t7;
  } else {
    t7 = $[31];
  }
  return t7;
}